const reasonList = ['Perdida', 'Renuncia', 'Desistió']

export default reasonList
